// The start page: what the conversation shows when it has no history (first sign-in, or after a
// reset). The Quanty One mark, a greeting and the workflows to start with; a click sends
// "Start <workflow>" as the person's first message. Rendered inside Thread's runtime provider, so
// the suggestion buttons send through the same path as the composer.
import { ThreadPrimitive } from "@assistant-ui/react";
import { QuantyMark } from "./Header.js";

export const WORKFLOWS = [
  "Signal Research",
  "Signal Validation",
  "Strategy Development",
  "Strategy Validation",
  "Strategy Attribution",
  "Full Quant Research Workflow",
] as const;

/** The message a workflow's box sends. */
export const startMessage = (workflow: string): string => `Start ${workflow}`;

export function Start() {
  return (
    <div className="flex flex-col items-center px-2 py-10 text-center sm:py-14">
      <QuantyMark className="size-16" />
      <h2 className="mt-5 text-xl font-semibold">Hi, I'm Quanty One, your AI Quant Researcher.</h2>
      <p className="mt-2 text-muted-foreground">What do you want to get started with?</p>
      <div className="mt-8 grid w-full max-w-2xl grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {WORKFLOWS.map((w) => (
          <ThreadPrimitive.Suggestion
            key={w}
            prompt={startMessage(w)}
            send
            className="cursor-pointer rounded-xl border border-border bg-card px-4 py-4 text-sm font-medium shadow-xs transition-colors hover:border-ring hover:bg-accent focus-visible:border-ring focus-visible:outline-none disabled:cursor-default disabled:opacity-50"
          >
            {w}
          </ThreadPrimitive.Suggestion>
        ))}
      </div>
    </div>
  );
}
